import extractErrorMessage from '../../utils/extractErrorMessage';
import { authClient } from '../../api/client';

export const fetchAwardEventSummary = async ({
  page = 1,
  limit = 10,
  userType = null,
}) => {
  try {
    const params = new URLSearchParams();
    params.append('page', String(page));
    params.append('limit', String(limit));
    if (userType) params.append('userType', userType);

    const response = await authClient.get(
      `/award-event/summary?${params.toString()}`
    );
    return {
      data: response.data.data,
      success: true,
      message: null,
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju podataka.'
    );
    return {
      data: null,
      success: false,
      notActive: error.response?.status === 403,
      message,
    };
  }
};

export const exportAwardEventSummary = async ({ userType = null }) => {
  try {
    const params = new URLSearchParams();
    if (userType) params.append('userType', userType);
    const query = params.toString() ? `?${params.toString()}` : '';

    const response = await authClient.get(
      `/award-event/summary/export${query}`,
      {
        responseType: 'blob',
      }
    );

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute(
      'download',
      `nagrada-2026-${new Date().toISOString().split('T')[0]}.csv`
    );
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return { success: true, message: 'Podaci uspešno izvezeni' };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri izvozu podataka.'
    );
    return {
      success: false,
      notActive: error.response?.status === 403,
      message,
    };
  }
};
